import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams } from '@mctic/ng-core';
import { EmpresaVO } from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class EmpresaContratanteService {

  private readonly endpoint = '/sepin-backend/rest/empresas-contratantes';

  constructor(private readonly http: McticHttpClient) {
  }

  consultarPorCnpj(cnpj: string) {
    const parametros = new McticHttpParams();
    parametros.set('cnpj', cnpj);
    return this.http.get<EmpresaVO[]>(this.endpoint, {params: parametros.toHttpParams()});
  }

}
